export default "__VITE_ASSET__81839972__"